"use client";
import clsx from "clsx";
import React from "react";

interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  textColor?: string;
  bgColor?: string;
  placeholder?: string;
  rows?: number;
  className?: string;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const TextArea: React.FC<TextAreaProps> = ({
  textColor,
  bgColor,
  placeholder,
  rows = 4,
  className,
  onChange,
  ...props // Use spread operator to collect all other props
}) => {
  return (
    <textarea
      onChange={onChange}
      placeholder={placeholder}
      rows={rows}
      className={clsx(
        "rounded-2xl border border-secondary-light px-6 py-4 transition-all duration-300 hover:border-grey-border focus:outline-none focus:ring-1 focus:ring-grey-border",
        bgColor ? `bg-${bgColor}` : "",
        textColor ? `text-${textColor}` : "", // Also fix this to use Tailwind classes properly
        className,
      )}
      {...props}
    />
  );
};

export default TextArea;
